// extracted by mini-css-extract-plugin
module.exports = {"feedPostV2":"feed_feedPostV2__BlCwj"};